import React from 'react';
import { Check } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ReportTechnicalDifficultiesSuccess = () => {
  return (
    <div className="d-f fd-c">
      <div className="d-f ai-c lh-20 pt-16">
        <Text
          className="d-f ai-c"
          variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD_SUCCESS}
        >
          <Check className="pr-8" />
          {t(
            'practice.on_demand_practice.report_technical_difficulties.success',
          )}
        </Text>
      </div>
    </div>
  );
};

export default ReportTechnicalDifficultiesSuccess;
